import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const AngleDoubleLeft = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className={className} onClick={onClick} ref={ref}>
    <path
      fill="currentColor"
      d="m224 239 136-136c9-9 24-9 34 0l22 23c10 9 10 24 0 33l-96 97 96 96c10 10 10 25 0 34l-22 23c-10 9-25 9-34 0L224 273c-10-9-10-25 0-34zM32 273l136 136c9 9 24 9 34 0l22-23c10-9 10-24 0-34l-96-96 96-96c10-10 10-25 0-34l-22-23c-10-9-25-9-34 0L32 239c-10 9-10 25 0 34z"
    />
  </svg>
));
